$(".slider__news").each(function (key, item) {
  $(this).slick({
    infinite: true,
    draggable: true,
    adaptiveHeight: false,
    accessibility: false,
    arrows: true,
    dots: false,
    prevArrow: "", // no prev arrow necessary
    nextArrow: $(this).parents(".slider").find(".slider__control--single"),
  });
});

$(".slider__images").each(function (key, item) {
  $(this).slick({
    infinite: true,
    draggable: true,
    accessibility: false,
    adaptiveHeight: false,
    arrows: true,
    prevArrow: $(this).parent().find(".slider__control--prev"),
    nextArrow: $(this).parent().find(".slider__control--next"),
  });
});



// WEBPACK FOOTER //
// ./assets/js/features/slides.js